import React, { useState, useContext, useCallback } from "react";
import AccordionContext from "react-bootstrap/AccordionContext";
import { Accordion, Card } from "react-bootstrap";
import Icon from "../Icon";
import "./CollapseMenu.css";

var CollapseMenu = function CollapseMenu(props) {
  var currentEventKey = useContext(AccordionContext);

  return React.createElement(
    Card,
    { className: "poli__container--collapse-menu", onClick: currentEventKey !== props.id ? props.doSomething : function () {
        return "";
      } },
    React.createElement(
      Accordion.Toggle,
      {
        as: Card.Header,
        className: "poli__header--collapse-menu" + (currentEventKey === props.id ? " active" : ""),
        eventKey: props.id
      },
      React.createElement(Icon, { size: 22, icon: props.principalIcon }),
      React.createElement(
        "span",
        { className: "align-title" },
        "         ",
        props.principalTitle
      ),
      currentEventKey === props.id ? React.createElement(Icon, {
        size: 16,
        icon: "poli-icon pi-simple-arrow-down-line-animation"
      }) : React.createElement(Icon, {
        size: 16,
        icon: "poli-icon pi-simple-arrow-right-line-animation"
      })
    ),
    React.createElement(
      Accordion.Collapse,
      { eventKey: props.id },
      React.createElement(
        Card.Body,
        null,
        props.children
      )
    )
  );
};

export default CollapseMenu;